import React from 'react';
import { useTranslation } from 'react-i18next';
import { getField } from 'src/utils/EntryUtil';
import { applyEntryDataAttributes } from '../EntryWrapper/EntryDataWrapper';
import { useProductPricing } from '../ProductPricing/ProductPricing';
import { IProductPrice } from './IProductPrice';

const ProductMonthlyPrice: React.FC<IProductPrice> = ({ entry, ...props }) => {
  const dcsId = getField(entry, 'dcsId');
  const { t } = useTranslation();
  const { productPricings } = useProductPricing();

  if (!dcsId || !productPricings) return null;

  const productPricing = productPricings.find(product => product?.id === dcsId);

  if (!productPricing) return null;

  const fullPrice = productPricing?.basePrice.value;
  const monthlyPayment = productPricing?.installmentPlans.IP3?.value;
  const termMonths = 3;

  if (!monthlyPayment || !fullPrice || fullPrice <= 200) return null;

  return <span {...props}>{t('product-monthly-price', { monthlyPayment, termMonths })}</span>;
};

const Wrapped = applyEntryDataAttributes(ProductMonthlyPrice);
type Wrapped = typeof Wrapped;

export { Wrapped as ProductMonthlyPrice };
